export default __webpack_public_path__ + "static/media/remove.b424fa12.svg";